<template>
  <div>
    <!-- Unpaid Students -->
    <div v-if="unpaidStudents.length">
      <div class="mb-2 text-danger font-weight-bold">
        {{ $t('paymentStatistic.studentUnPaid') }} ({{ unpaidStudents.length }})
      </div>
      <Table
        :columns="columns"
        :data="unpaidStudentsWithIndex"
        size="small"
        max-height="350"
        bordered
      >
        <template slot-scope="{ row }" slot="index">{{ row.index }}</template>
        <template slot-scope="{ row }" slot="card_number">{{
          row.card_number
        }}</template>
        <template slot-scope="{ row }" slot="student_name_kh">{{
          row.student_name_kh
        }}</template>
        <template slot-scope="{ row }" slot="student_name_en">{{
          row.student_name_en
        }}</template>
        <template slot-scope="{ row }" slot="gender">{{ row.gender }}</template>
        <template slot-scope="{ row }" slot="phone_number">{{
          row.phone_number
        }}</template>
      </Table>
    </div>

    <!-- Paid Students -->
    <div v-if="paidStudents.length">
      <div class="mt-2 text-success font-weight-bold">
        {{ $t('paymentStatistic.studentPaid') }} ({{ paidStudents.length }})
      </div>
      <Table
        :columns="columns"
        :data="paidStudentsWithIndex"
        size="small"
        max-height="350"
        bordered
      >
        <template slot-scope="{ row }" slot="index">{{ row.index }}</template>
        <template slot-scope="{ row }" slot="card_number">{{
          row.card_number
        }}</template>
        <template slot-scope="{ row }" slot="student_name_kh">{{
          row.student_name_kh
        }}</template>
        <template slot-scope="{ row }" slot="student_name_en">{{
          row.student_name_en
        }}</template>
        <template slot-scope="{ row }" slot="gender">{{ row.gender }}</template>
        <template slot-scope="{ row }" slot="phone_number">{{
          row.phone_number
        }}</template>
      </Table>
    </div>

    <!-- No data -->
    <div
      v-if="!paidStudents.length && !unpaidStudents.length"
      class="text-center text-muted mt-3"
    >
      {{ $t('paymentStatistic.noStudents') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'table-expand',
  props: {
    paidStudents: { type: Array, default: () => [] },
    unpaidStudents: { type: Array, default: () => [] }
  },
  computed: {
    paidStudentsWithIndex() {
      return this.paidStudents.map((s, idx) => ({ ...s, index: idx + 1 }))
    },
    unpaidStudentsWithIndex() {
      return this.unpaidStudents.map((s, idx) => ({ ...s, index: idx + 1 }))
    },
    columns() {
      return [
        {
          title: this.$t('numberic'),
          key: 'index',
          width: 60,
          align: 'center',
          slot: 'index'
        },
        {
          title: this.$t('paymentStatistic.cardNumber'),
          key: 'card_number',
          slot: 'card_number',
          align: 'center'
        },
        {
          title: this.$t('paymentStatistic.studentNameKh'),
          key: 'student_name_kh',
          slot: 'student_name_kh'
        },
        {
          title: this.$t('paymentStatistic.studentName'),
          key: 'student_name_en',
          slot: 'student_name_en'
        },
        {
          title: this.$t('paymentStatistic.gender'),
          key: 'gender',
          slot: 'gender'
        },
        {
          title: this.$t('paymentStatistic.phoneNumber'),
          key: 'phone_number',
          slot: 'phone_number'
        }
      ]
    }
  }
}
</script>

<style scoped>
.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.font-weight-bold {
  font-weight: 600;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem;
}
</style>
